module.exports = __webpack_public_path__ + "img/team-2-800x800.dcfcf3b7.jpg";